import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../EmptyFragment';
import { findLink } from '../../../LinkyLinky';
import ParticipantsStore from '../../../ParticipantsStore';
import { ParticipantsOptionsResource } from '../../../ParticipantsStore/Options/Types';
import GenericSortFilter from '../../GenericSortFilter';
import { StringOption } from '../../Options/Types';
import OrganizationFilter from '../Filters/OrganizationFilter';
import ProgramsFilter from '../Filters/ProgramsFilter';
import Search from '../Filters/Search';

interface Props {
  participantsOptionsResource: ParticipantsOptionsResource;
  participantsStore: ParticipantsStore;
  selectedOrganization: Maybe<StringOption>;
}

function GeneralFilters({
  participantsStore,
  participantsOptionsResource,
  selectedOrganization,
}: Props) {
  const participantsOptions = participantsOptionsResource.payload;
  return (
    <>
      <Search store={participantsStore} label="Search Name or Email" className="w-2/6" />
      <OrganizationFilter
        selectedOrganization={selectedOrganization}
        updatingOrganizationParameters={participantsStore.updatingOrganizationParameters}
        className="mr-4 w-2/6"
      />
      <div className="mr-4 w-2/6">
        <GenericSortFilter
          labelText="Group"
          options={participantsOptions.userGroups}
          parameters={participantsStore.searchParameters}
          updatingParameters={participantsStore.updatingSearchParameters}
          sortFilterKey={'user_group'}
        />
      </div>
      <div className="mr-4 w-2/6">
        <GenericSortFilter
          labelText="Collection"
          options={participantsOptions.learningCollections}
          parameters={participantsStore.searchParameters}
          updatingParameters={participantsStore.updatingSearchParameters}
          sortFilterKey={'learning_collection'}
        />
      </div>
      {findLink('options', participantsOptionsResource.links)
        .map((link) => <ProgramsFilter link={link} participantsStore={participantsStore} />)
        .getOrElse(emptyFragment)}
    </>
  );
}

export default observer(GeneralFilters);
